import { Outlet } from 'react-router';

import QuizBuilderHeader from '@/components/features/quiz/quiz-builder/QuizBuilderHeader';

export default function QuizBuilderHeaderLayout() {
  return (
    <>
      <QuizBuilderHeader />
      <Outlet />
    </>
  );
}
